import { useAtom } from "jotai";

import { $accessTokenFunc, $isAuthenticated, $loggedInUser } from "../../internal/authenication";

export const useAuth = () => {
	const [getAccessTokenSilently, setGetAccessTokenSilently] = useAtom($accessTokenFunc);
	const [isAuthenticated, setIsAuthenticated] = useAtom($isAuthenticated);
	const [loggedInUser, setLoggedInUser] = useAtom($loggedInUser);

	return {
		setIsAuthenticated,
		setLoggedInUser,
		getAccessTokenSilently,
		setGetAccessTokenSilently,
		isAuthenticated,
		loggedInUser,
	};
};
